<template>
  <v-card outlined class="m-2">
    <v-container>
      <span class="headline mb-1">{{ group.groupName.toUpperCase() }}</span>

      <v-card-text>
        <v-row column wrap>
          <span class="subtitle-1"><b>Authorization level</b></span>
          <v-col class="d-flex">
            <p>{{ group.userRole }}</p>
            <v-spacer></v-spacer>
            <icon
              scale="1.4"
              v-if="isAdmin"
              class="grey--text lighten-5"
              name="user-cog"
            ></icon>
            <icon
              scale="1.4"
              v-else
              class="grey--text lighten-5"
              name="eye"
            ></icon>
          </v-col>
        </v-row>
        <v-divider class="m-0"></v-divider>
        <v-row column wrap>
          <span class="subtitle-1"><b>Created on</b></span>
          <v-col class="d-flex">
            <p>{{ group.createdDate.split('T')[0] }}</p>
            <v-spacer></v-spacer>
            <icon
              scale="1.4"
              class="grey--text lighten-5"
              name="calendar-day"
            ></icon>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="teal lighten-2 rounded-edges">
        <v-col cols="4" class="text-center">
          <v-dialog width="650" persistent v-model="usersDialog">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
                @click="getUsersInGroup()"
                :disabled="!isAdmin"
              >
                <v-icon class="white--text">people</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-container class="pt-0">
                <v-card-title>
                  <span class="headline">Users in group</span>
                </v-card-title>
                <v-divider class="mt-0 mb-3"></v-divider>
                <v-card-text>
                  <p class="body-2 m-0 grey--text">SHARE WITH</p>
                  <div
                    class="d-flex"
                    v-for="(user, index) in usersInGroup"
                    :key="index"
                  >
                    <v-col cols="7" mr-2>
                      <v-text-field
                        disabled
                        v-model="user.email"
                        label="E-mail"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        disabled
                        v-model="user.auth"
                        label="User authorization"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="user.email !== currentUser.email"
                      cols="1"
                      class="pt-2"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            class="grey--text darken-4"
                            @click="removeExistentUser(index)"
                          >
                            <v-icon size="29">delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Remove user</span>
                      </v-tooltip>
                    </v-col>
                  </div>
                  <v-form v-model="addUserGroupFormValid" ref="usersgroupform">
                    <div
                      class="d-flex"
                      v-for="(user, index) in shareWith"
                      :key="index"
                    >
                      <v-col cols="7" mr-2>
                        <v-text-field
                          v-model="user.email"
                          label="E-mail"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          :items="authOptions"
                          v-model="user.auth"
                          :rules="authRules"
                          label="User authorization"
                          :hint="
                            user.auth === 'Admin'
                              ? 'User can import and export data'
                              : 'User can only import data'
                          "
                        ></v-select>
                      </v-col>
                      <v-col cols="1" class="pt-2">
                        <v-tooltip top>
                          <template iconv-slot:activator="{ on }">
                            <v-btn
                              class="grey--text darken-4"
                              @click="removeUser(index)"
                            >
                              <v-icon size="29">delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Remove user</span>
                        </v-tooltip>
                      </v-col>
                    </div>
                  </v-form>
                  <div class="text-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="primary" v-on:click="addUserToGroup()">
                          <v-icon class="mr-1" size="29">add</v-icon> Add user
                        </v-btn>
                      </template>
                      <span>Add user</span>
                    </v-tooltip>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="primary"
                    depressed
                    :loading="loaderNotif"
                    :disabled="!addUserGroupFormValid"
                    @click="saveChanges()"
                    >Save changes</v-btn
                  >
                  <v-btn
                    color="primary"
                    depressed
                    @click="resetUsersForm()"
                    outlined
                    >Cancel</v-btn
                  >
                </v-card-actions>
              </v-container>
            </v-card>
          </v-dialog>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="4" class="text-center">
          <v-dialog v-model="sharedElementsDialog" width="90%">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon class="white--text">list</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline black white--text" primary-title>
                Shared missions
                <v-spacer></v-spacer>
                <v-btn icon @click="resetImport()">
                  <v-icon class="white--text">close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <group-import :groupId="this.group.id"></group-import>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="4" class="text-center">
          <v-dialog max-width="400" v-model="deleteDialog">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" :disabled="!isAdmin">
                <v-icon class="white--text">delete</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-container>
                <v-card-title class="justify-center p-0">
                  <span class="headline">Delete Group</span>
                  <v-spacer></v-spacer>
                  <v-btn icon small class="m-0" @click="deleteDialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text-center p-1">
                  <p class="body-1">
                    Are you sure that you want to delete this group?
                  </p>
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-btn color="primary" @click="deleteGroup()">Delete</v-btn>
                </v-card-actions>
              </v-container>
            </v-card>
          </v-dialog>
        </v-col>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
import errorMixin from '../../mixins/logHandler.js'
import { mapGetters } from 'vuex'
export default {
  name: 'group-card',
  mixins: [errorMixin],
  props: {
    group: Object
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' }),
    isAdmin() {
      return this.group.userRole === 'ADMIN'
    }
  },
  data() {
    return {
      emailRegex:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      authOptions: ['Admin', 'View'],
      sharedElementsDialog: false,
      usersDialog: false,
      deleteDialog: false,
      addUserGroupFormValid: false,
      loaderNotif: false,
      usersInGroup: [],
      deleteUserInGroup: [],
      shareWith: [],
      emailRules: [
        (v) => this.emailRegex.test(v) || 'E-mail must be valid',
        (v) => !!v || 'E-mail is required'
      ],
      authRules: [(v) => !!v || 'Authorization is required']
    }
  },
  methods: {
    async getUsersInGroup() {
      let self = this
      await this.$http
        .get(
          '/groups/' +
            this.currentUser.id +
            '/' +
            this.group.id +
            '/usersingroup'
        )
        .then(async function (response) {
          for (let key of Object.keys(response.data)) {
            self.usersInGroup.push({ email: key, auth: response.data[key] })
          }
        })
        .catch((e) => {
          self.resetUsersForm()
          self.displayMessage(
            'Error getting list of users in group. ',
            e,
            'notification',
            'error'
          )
        })
    },

    addUserToGroup() {
      this.shareWith.push({
        email: '',
        auth: ''
      })
    },

    resetUsersForm() {
      this.loaderNotif = false
      this.addUserGroupFormValid = false
      this.usersDialog = false
      this.usersInGroup = []
      this.shareWith = []
      this.$refs.usersgroupform.reset()
      this.$refs.usersgroupform.resetValidation()
    },

    removeUser(index) {
      this.shareWith.splice(index, 1)
    },

    removeExistentUser(index) {
      this.deleteUserInGroup.push(this.usersInGroup.splice(index, 1)[0])
    },

    async saveChanges() {
      let self = this
      self.loaderNotif = true
      await this.$http
        .put(
          '/groups/' +
            this.currentUser.id +
            '/' +
            this.group.id +
            '/savenewusers',
          { delete: this.deleteUserInGroup, add: this.shareWith }
        )
        .then(async function (response) {
          self.resetUsersForm()
          switch (response.status) {
            case 206:
              self.displayMessage(response.data, '', 'notification', 'warning')
              break
            default:
              self.displayMessage(
                'The changes were saved successfully.',
                '',
                'notification',
                'success'
              )
              break
          }
        })
        .catch((e) => {
          self.resetUsersForm()
          self.displayMessage(
            'Error getting list of users in group. ',
            e,
            'notification',
            'error'
          )
        })
    },

    resetImport() {
      this.sharedElementsDialog = false
    },

    deleteGroup() {
      let self = this
      this.$http
        .delete(
          '/groups/' +
            this.currentUser.id +
            '/' +
            this.group.id +
            '/deletegroup'
        )
        .then(async function (response) {
          self.displayMessage(
            'Group ' + self.group.name + ' was deleted successfully.',
            '',
            'notification',
            'success'
          )
          self.$root.$emit('update-groups-list')
        })
        .catch((e) => {
          self.displayMessage(
            'Error deleting group ' + this.group.name + '. ',
            e,
            'notification',
            'error'
          )
        })
    }
  }
}
</script>

<style scoped>
.rounded-edges {
  border-radius: 50px;
}
</style>
